import { toast } from "sonner";
import request from "../../../../helpers/request";
import { IUpdateConfigPtDigital } from "../types";

const DTO = (data: IUpdateConfigPtDigital) => {
  const {
    idLoja,
    idEquipamento,
    idGrupoMonitor,
    toleranciaTime,
    coordX,
    coordY,
    hrMsgEscaladaNV2,
    minMsgEscaladaNV2,
    hrMsgEscaladaNV3,
    minMsgEscaladaNV3,
  } = data;

  const checkDataEscalada = (data) => (!data ? "00" : data);

  return {
    ...data,
    idLoja: Number(idLoja),
    idEquipamento: Number(idEquipamento),
    idGrupoMonitor: Number(idGrupoMonitor),
    toleranciaTime: Number(toleranciaTime),
    coordX: Number(coordX),
    coordY: Number(coordY),
    timeMsgEscaladaNV2: `${checkDataEscalada(hrMsgEscaladaNV2)}:${checkDataEscalada(minMsgEscaladaNV2)}`,
    timeMsgEscaladaNV3: `${checkDataEscalada(hrMsgEscaladaNV3)}:${checkDataEscalada(minMsgEscaladaNV3)}`,
    msgNormalCustom: "",
    msgFalhaCustom: "",
  };
};

export const updateConfigPtMonDigital = async (
  idPt: string,
  props: IUpdateConfigPtDigital,
) => {
  try {
    const url = `${process.env.REACT_APP_API}/MonDigital/${idPt}`;
    const data = DTO({
      ...props,
    });

    delete data.hrMsgEscaladaNV2;
    delete data.minMsgEscaladaNV2;
    delete data.hrMsgEscaladaNV3;
    delete data.minMsgEscaladaNV3;

    const result = await request({
      url,
      method: "put",
      data,
      headers: { "Content-Type": "application/json" },
    });

    if (result.data.toLowerCase() === "ok") {
      toast.success("Ponto de monitoramento digital atualizado com sucesso.");
      return result;
    } else {
      if (process.env.NODE_ENV === "development") {
        console.error("Error updating digital monitoring point:", result.data);
      }
      toast.error(
        result.data || "Erro ao atualizar o ponto de monitoramento digital. Por favor, tente novamente.",
      );
    }
  } catch (error: any) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Erro ao processar a requisição. Por favor, tente novamente.",
        error,
      );
    }

    const mensagemApi =
      error?.response?.data?.mensagem ??
      error?.response?.data ??
      error?.message;

    toast.error(
      typeof mensagemApi === "string" && mensagemApi.trim()
        ? mensagemApi
        : "Erro ao processar a requisição. Por favor, tente novamente.",
    );
  }
};